const { remToPx } = require('./../../../_global/js/utility/utils');
import initContactAnimation from './../components/contactAnimation';
import { gsap } from 'gsap';
import Swiper, { Pagination } from 'swiper';
Swiper.use([Pagination]);

import { enableLogo } from './../components/logo';

import { isDark, hexToRgb } from './../../../_global/js/utility/luminosity';

import validateForm from './../../../_global/js/components/validateForm';

// import initScrollMagic from './../scrollMagic/home';



const initOpeningSwiper = () => {
  console.log('init opening swiper');
  const opening = document.querySelector('.opening');

  const openingSwiper = new Swiper('.opening-swiper', {
    speed: 600,
    spaceBetween: remToPx(2),
    slidesPerView: 1,
    loop: true,

    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },

    on: {
      // change slider background gradient
      slideChangeTransitionEnd: function() {
        // let activeSlide = document.querySelector(`[data-swiper-slide-index="${this.activeIndex - 1}"]`);
        let activeSlide = document.querySelector('.swiper-slide-active');

        if (!activeSlide) return;

        let gradient = {
          left: activeSlide.getAttribute('data-color-left'),
          right: activeSlide.getAttribute('data-color-right')
        };

        gsap.to(opening, {
          backgroundImage: `linear-gradient(107.56deg, ${gradient.left} 0%, ${gradient.right} 100%)`,
          duration: 1
        });

        // check if color is too dark
        let color = {
          r: hexToRgb(gradient.left).r,
          g: hexToRgb(gradient.left).g,
          b: hexToRgb(gradient.left).b
        };

        if (isDark(color.r, color.g, color.b) === 'dark') {
          console.log('SLIDE IS DARK');
          opening.classList.add('opening--dark');
        } else {
          console.log('SLIDE IS BRIGHT');
          opening.classList.remove('opening--dark');
        }
      }
    }
  });
}



const initTestimonialSwiper = () => {
  const testimonialSwiper = new Swiper('.testimonial-swiper', {
    speed: 400,
    spaceBetween: remToPx(2),
    slidesPerView: 1,
    loop: true,
    centeredSlides: true,

    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },

    breakpoints: {
      960: {
        slidesPerView: 2,
        // spaceBetween: remToPx(12),
      }
    }
  });
}



/*
 * barba views
 */
const Home = {
  namespace: 'home',

  beforeLeave: (data) => {
    console.log('view home beforeLeave');
  },

  afterLeave: (data) => {
    console.log('view home afterLeave');
  },
  //
  // beforeEnter: (data) => {
  //
  // },
  //
  // afterEnter: (data) => {
  //
  // },


  beforeEnter: (data) => {
    console.log('view home beforeEnter');
  },
  afterEnter: (data) => {
    console.log('view home afterEnter');

    initOpeningSwiper();
    initTestimonialSwiper();
    initContactAnimation(data.next.container);
    // enableLogo('white');

    // initScrollMagic();

    let formsToValidate = document.querySelectorAll('form[data-validate]');
    formsToValidate.forEach(form => validateForm(form, {
    	showErrors: false,
    }));

    document.addEventListener('pageTransitionEnd', () => {
      console.log('DONEEEE');
    });
  }
}

export default Home;
